import { api } from "@api/api";
import { AgreementPlan } from "@modules/agreementPlans/types";
import { AgreementPlanFormValues } from "@modules/agreementPlans/validations";

export async function editAgreementPlanService(id: string, data: Partial<AgreementPlanFormValues>): Promise<AgreementPlan> {
  const { data: agreementPlan } = await api.patch<AgreementPlan>(`v1/agreement_plans/${id}/`, data);

  return agreementPlan;
}
